import dayjs from 'dayjs';

import { transformDate } from '../pipes/ocr-date.pipe';

export const formatDate = (value: string | undefined): string | null =>
  value ? transformDate(value).format('YYYY-MM-DD') : null;

/** Inverse of formatDate: backend dates are ISO, the extraction forms expect the german format. */
export const toGermanDate = (value: string | null | undefined): string | null => {
  if (!value) {
    return null;
  }

  const date = dayjs(value);

  return date.isValid() ? date.format('DD.MM.YYYY') : null;
};
